// Copy centralizado de la seccion "Fichas de cata". El admin no usa i18next;
// para no dispersar los strings en cada componente los agrupamos aca. Claves en
// ingles, copy en espanol (ver AGENTS.md).

export const fichasCopy = {
  sectionTitle: 'Fichas de cata',
  sectionDescriptionAdmin:
    'Fichas de referencia de docentes y admins que los alumnos pueden comparar contra las suyas.',
  sectionDescriptionDocente: 'Tus fichas de referencia para que los alumnos comparen sus catas.',
  newFicha: 'Nueva ficha',
  status: {
    draft: 'Borrador',
    published: 'Publicado',
  },
  columns: {
    vino: 'Vino',
    varietal: 'Varietal',
    bodega: 'Bodega',
    autor: 'Autor',
    status: 'Estado',
    fecha: 'Fecha',
    acciones: 'Acciones',
  },
  filters: {
    search: 'Buscar por vino',
    searchPlaceholder: 'Nombre del vino...',
    status: 'Estado',
    statusAll: 'Todos',
    author: 'Autor',
    authorPlaceholder: 'Nombre del autor...',
  },
  actions: {
    edit: 'Editar',
    publish: 'Publicar',
    unpublish: 'Despublicar',
    delete: 'Eliminar',
    saveDraft: 'Guardar borrador',
    saveChanges: 'Guardar cambios',
    cancel: 'Cancelar',
  },
  empty: {
    title: 'Aún no hay fichas de referencia',
    description: 'Crea la primera ficha para que los alumnos puedan comparar sus catas.',
  },
  deleteDialog: {
    title: 'Eliminar ficha',
    confirm: (vino: string): string =>
      `"${vino || 'Sin nombre'}" se va a eliminar. Esta acción no se puede deshacer.`,
  },
  publishDialog: {
    publishTitle: 'Publicar ficha',
    unpublishTitle: 'Despublicar ficha',
    publishConfirm: (vino: string): string =>
      `"${vino || 'Sin nombre'}" va a quedar visible para los alumnos como ficha de referencia.`,
    unpublishConfirm: (vino: string): string =>
      `"${vino || 'Sin nombre'}" va a dejar de estar visible para los alumnos.`,
  },
  newTitle: 'Nueva ficha de cata',
  newDescription: 'Carga una ficha de referencia. Arranca en borrador; luego podés publicarla.',
  editTitle: 'Editar ficha de cata',
  editDescription: 'Actualiza la ficha de referencia.',
  toasts: {
    created: 'Ficha creada',
    updated: 'Ficha actualizada',
    deleted: 'Ficha eliminada',
    published: 'Ficha publicada',
    unpublished: 'Ficha despublicada',
    invalid: 'Revisá los datos de la ficha antes de guardar.',
    notPublishable:
      'Para publicar, cargá el nombre del vino y al menos una respuesta sensorial comparable.',
    draftIncomplete:
      'Se guardó el borrador, pero todavía no cumple lo mínimo para publicar (nombre del vino + una respuesta comparable).',
    createError: 'No pudimos crear la ficha.',
    updateError: 'No pudimos guardar los cambios.',
    deleteError: 'No pudimos eliminar la ficha.',
    loadError: 'No pudimos cargar la ficha.',
    imageUploaded: 'Foto del vino actualizada',
    imageRemoved: 'Foto del vino eliminada',
    imageError: 'No pudimos subir la foto.',
    imageRemoveError: 'No pudimos eliminar la foto.',
    imageTooLarge: 'La imagen supera el máximo de 5 MB.',
    imageBadType: 'Formato inválido. Usá JPG, PNG o WebP.',
  },
  imagen: {
    title: 'Foto del vino',
    description: 'Opcional. Se muestra a los alumnos cuando la ficha está publicada.',
    upload: 'Subir foto',
    replace: 'Cambiar foto',
    remove: 'Quitar foto',
    empty: 'Sin foto',
    savedHint: 'Guardá la ficha primero para poder subir una foto.',
  },
} as const
